import { IS_CLIENT, SESSION_STORAGE_KEYS } from "@shared/constants";

export function getIsKeysOnlyMode() {
  if (!IS_CLIENT) {
    return false;
  }

  return sessionStorage.getItem(SESSION_STORAGE_KEYS.SHOW_KEYS) === "true";
}
